import Program from 'nanogl/program'

import code from '../glsl/fetch.frag'
import BaseEffect from './base-effect'

export default class Fetch extends BaseEffect {
  _code: string

  constructor() {
    super()
    this._code = code()
  }

  genCode(precode: string[], code: string[]) {
    code.push(this._code)
  }

  init(): void {}
  release(): void {}
  preRender(): void {}
  setupProgram(prg: Program): void {}
  resize(w: number, h: number): void {}
}
